/** @jsxImportSource @emotion/react */
import * as React from 'react';
import { ResortToolsLogo } from '../branding/ResortToolsLogo';
import { css } from '@emotion/react';
import { FADE_IN_ANIMATION } from '../styles/animations';
import { SearchHistory } from './SearchHistory';


/**
 * ResultsPlaceholder: a component that shows when there are no results to show. Seen on the Guest Search page
 *
 * PureComponent: true
 * Redux Connected: false
 */
type Props = {
  resources: Record<string, any>,
  enableSearchHistory: boolean
}

export const ResultsPlaceholder = React.memo(function ResultsPlaceholder(props: Props) {

  return( 
  <div>
    <ResortToolsLogo 
      resources={props.resources} 
      rootCss={css`height: 100%; margin-top: 50px; margin-bottom: auto; ${FADE_IN_ANIMATION};`}/>
    {props.enableSearchHistory &&
        <SearchHistory />
    }
    
  </div>
  );
});
